import axios from 'axios'
import router from '../router'
import { base64Jiami, getUserInfoCache } from '@/tools/common';

import { Toast } from 'vant';
import {isBondo} from "../util";
import {base64JiamiBondo} from "../tools/common";
const isInBondo = isBondo();
const baseUrl = isInBondo ? process.env.bondoBaseUrl : process.env.weiApiUrl;
export const newClient = function (env) {

  let userInfo = getUserInfoCache();
  let token=userInfo ? userInfo.token : '';
  let systoken=userInfo ? userInfo.systoken : '';
  let apiCommon = base64Jiami({
    token: token
  });
  let headers = {
    "systoken": token,
    "api_common":apiCommon,
  }
  if(isInBondo) {
    apiCommon = base64JiamiBondo({
      token: token,
      systoken: systoken
    })
    headers = {
      bondo_param: apiCommon
    }
  }
  console.log(`output->apiCommon`,apiCommon)
  // 如果是bondo环境，则使用bondo的baseUrl，否则使用默认的baseUrl
  const newClient = axios.create({
    // baseURL: env === 'gchao' ? process.env.baseURL : process.env.weiApiUrl,
    baseURL: baseUrl,
    timeout: 2*60*1000,
    headers: headers,
    withCredentials: true,
  })
  newClient.interceptors.response.use((response) => {

    const data = response.data
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      // 文件下载
      return response;
    }
    if (data.code === 2 || (isInBondo && data.code === 40001)) {
      // 未登录 或者token过期
      localStorage.setItem("userInfo", '');
      localStorage.removeItem("userInfo");
      router.push({
        path: '/login'
      })
    } else if(data.code === 40003){
      Toast(window.rootApp.$t('m.device_is_more'));
    } else if(data.code === 40006){
      Toast(window.rootApp.$t('m.Operation_failed'));
    } else {
      return response
      // return Promise.reject(response)
    }
  }, (error) => {
    // 超时错误本地化：把 axios 默认的 "timeout of xxxms exceeded" 改成"网络繁忙"
    // 调用方通常 Toast(error.message)，改 message 即可让显示对的文案，不主动 Toast 避免干扰静默接口
    if (error && (error.code === 'ECONNABORTED' || (error.message && /timeout/i.test(error.message)))) {
      try {
        const msg = (window.rootApp && window.rootApp.$t) ? window.rootApp.$t('m.netword_busy_try') : 'Network busy, please try again';
        error.message = msg;
      } catch (e) {}
    }
    return Promise.reject(error)
  })
  return newClient
}



// WEBPACK FOOTER //
// ./src/api/axios-client-new.js